// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__dr1Ar","loader":"loader_loader__ayzXY"};